module.exports = __webpack_public_path__ + "img/1.acd11691.png";